import FormSidebar from '@src/components/layout/FormSidebar'
import HeadHtml from '@src/components/layout/HeadHtml'
import ActionPublish from '@src/components/widgets/ActionPublish'
import PageHeader from '@src/components/widgets/PageHeader'
import { labelStyle } from '@src/configs/const.config'
import { EKeyOption } from '@src/modules/option'
import { useMutationCreateOption, useQueryOptionByKey } from '@src/queries/hooks/option'
import { Card, Col, Collapse, Form, Row } from 'antd'
import { useMemo } from 'react'
import TinymceInput from '@src/components/widgets/TinymceInput'

const KEY = EKeyOption.POLICY

function OptionPageTermPolicy() {
  const [form] = Form.useForm()
  const { mutate: updateOption, isLoading: isLoadingUpdate } = useMutationCreateOption()

  const { data: option, isLoading, refetch } = useQueryOptionByKey({ 'key[]': [KEY] })
  const values = useMemo(() => option?.data[0], [option])

  const onFinish = (value: any) => {
    const options = [
      {
        key: KEY,
        value: {
          term: value.term,
          policy: value.policy,
        },
      },
    ]
    updateOption(
      { options },
      {
        onSuccess: () => {
          refetch()
        },
      },
    )
  }

  return (
    <Col span={24}>
      <HeadHtml title="Option Term & Policy Screen" />
      <FormSidebar onFinish={onFinish} form={form} name="formOptions" isLoading={isLoading}>
        <>
          <FormSidebar.Content>
            <Card hoverable title={<PageHeader title="TERM & POLICY" isSearch={false} inCard />}>
              <Collapse defaultActiveKey={['1', '2']}>
                <Collapse.Panel header="Key: TERM" key="1">
                  <Form.Item name="term" {...labelStyle} initialValue={values?.value?.term}>
                    <TinymceInput
                      {...labelStyle}
                      initialValue={values?.value?.term}
                      onEditorChange={(v) => form.setFieldsValue({ term: v })}
                      h={500}
                    />
                  </Form.Item>
                </Collapse.Panel>
                <Collapse.Panel header="Key: POLICY" key="2">
                  <Form.Item name="policy" {...labelStyle} initialValue={values?.value?.policy}>
                    <TinymceInput
                      {...labelStyle}
                      initialValue={values?.value?.policy}
                      onEditorChange={(v) => form.setFieldsValue({ policy: v })}
                      h={500}
                    />
                  </Form.Item>
                </Collapse.Panel>
              </Collapse>
            </Card>
          </FormSidebar.Content>
          <FormSidebar.Sidebar>
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <ActionPublish
                  data={{
                    createdAt: values?.createdAt,
                  }}
                  onPublish={() => form.submit()}
                  onUpdate={() => form.submit()}
                  loadingPublish={isLoadingUpdate}
                  loadingUpdate={isLoadingUpdate}
                />
              </Col>
            </Row>
          </FormSidebar.Sidebar>
        </>
      </FormSidebar>
    </Col>
  )
}

export default OptionPageTermPolicy
